import { createLogger } from "utils/logging";

const log = createLogger("cinema", "storefront");

export class StorefrontCinema {
	init() {
		log.info("Initialize StorefrontCinema");
	}
}
